module.exports = __webpack_public_path__ + "7e4b29ba/img/note-list-icon.961c1485.svg";